import { render, staticRenderFns } from "./caseProduct.vue?vue&type=template&id=f987bba0&scoped=true"
import script from "./caseProduct.vue?vue&type=script&lang=js"
export * from "./caseProduct.vue?vue&type=script&lang=js"
import style0 from "./caseProduct.vue?vue&type=style&index=0&id=f987bba0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f987bba0",
  null
  
)

export default component.exports